// Defines the standard Yes/No choices for boolean fields.
export const YES_NO_CHOICES = [
  { value: true, name: "Yes" },
  { value: false, name: "No" },
];

// Options for how often smoke alarms are tested.
export const SMOKE_ALARM_TEST_FREQUENCY_OPTIONS = [
  { value: "Weekly", name: "Weekly" },
  { value: "Monthly", name: "Monthly" },
  { value: "Quarterly", name: "Quarterly" },
  { value: "Annually", name: "Annually" },
  { value: "Never", name: "Never" },
];

// Options for the final assessed risk level.
export const RISK_LEVEL_OPTIONS = [
  { value: "Low", name: "Low" },
  { value: "Medium", name: "Medium" },
  { value: "High", name: "High" },
];

// // Defines the initial state for the form.
export const initialFormData = {
  care_plan: "",
  has_working_smoke_alarms: null,
  is_accommodation_rented: null,
  has_smoke_alarm_on_each_level: null,
  smoke_alarm_test_frequency: "",
  wants_fire_brigade_referral: null,
  does_anyone_smoke_in_home: null,
  do_they_smoke_in_bed: null,
  are_ashtrays_left_on_armchairs: null,
  does_anyone_smoke_ecigarettes: null,
  cook_after_drinking_alcohol: null,
  has_traditional_chip_pan: null,
  has_cooking_build_up: null,
  is_toaster_kettle_under_cupboard: null,
  switch_off_appliances_before_bed: null,
  leave_appliances_charging_overnight: null,
  put_laundry_on_overnight: null,
  use_electrical_devices_in_bathroom: null,
  use_electric_blankets: null,
  use_block_adapters_or_extensions: null,
  use_hair_straighteners: null,
  use_mobility_scooter: null,
  use_portable_heaters: null,
  clothes_dried_near_fire: null,
  use_wood_burning_stove: null,
  is_chimney_swept_yearly: null,
  use_lit_candles_or_incense: null,
  use_plugin_air_fresheners: null,
  use_wheat_bags: null,
  are_wheelie_bins_stored_away: null,
  are_internal_doors_closed_at_night: null,
  are_appliances_unplugged_at_night: null,
  are_candles_left_burning: null,
  are_keys_accessible: null,
  has_escape_plan: null,
  are_hallways_clear: null,
  can_escape_through_all_exits: null,
  has_mobility_difficulties: null,
  has_mental_illness: null,
  takes_medication_preventing_hearing_alarm: null,
  has_hearing_impairment: null,
  has_visual_impairment: null,
  consumes_alcohol_or_drugs: null,
  is_anyone_over_65: null,
  is_anyone_under_16: null,
  is_anyone_under_5: null,
  does_anyone_use_oxygen_at_home: null,
  has_arson_threat_concerns: null,
  comment_recommendation: "",
  risk_level: "",
};

export const sections = [
  {
    title: "Smoke Alarms & Smoking",
    questions: [
      {
        key: "has_working_smoke_alarms",
        label: "Do you have working smoke alarms?",
      },
      {
        key: "is_accommodation_rented",
        label: "Is the accommodation rented?",
      },
      {
        key: "has_smoke_alarm_on_each_level",
        label: "Do you have a working smoke alarm on each level?",
      },
      {
        key: "smoke_alarm_test_frequency",
        label: "How often do you test smoke alarms?",
      },
      {
        key: "wants_fire_brigade_referral",
        label: "Would you like a referral to the fire brigade?",
      },
      {
        key: "does_anyone_smoke_in_home",
        label: "Does anyone smoke in your home?",
      },
      { key: "do_they_smoke_in_bed", label: "Do they smoke in bed?" },
      {
        key: "are_ashtrays_left_on_armchairs",
        label: "Are ashtrays left on armchairs?",
      },
      {
        key: "does_anyone_smoke_ecigarettes",
        label: "Does anyone smoke e-cigarettes?",
      },
    ],
  },
  {
    title: "Kitchen & Electrical",
    questions: [
      {
        key: "cook_after_drinking_alcohol",
        label: "Does anyone cook after drinking alcohol?",
      },
      {
        key: "has_traditional_chip_pan",
        label: "Do you have a traditional chip pan?",
      },
      {
        key: "has_cooking_build_up",
        label:
          "Has your cooking equipment got a build-up of grease or cooking fat residue?",
      },
      {
        key: "is_toaster_kettle_under_cupboard",
        label: "Is your toaster or kettle positioned underneath a cupboard?",
      },
      {
        key: "switch_off_appliances_before_bed",
        label:
          "Do you switch off non-essential electrical appliances before you go to bed? (Kettle etc)",
      },
      {
        key: "leave_appliances_charging_overnight",
        label:
          "Do you leave electrical appliances, such as phones or computers, charging overnight?",
      },
      {
        key: "put_laundry_on_overnight",
        label:
          "Do you put a washing machine, tumble drier or dishwasher on overnight?",
      },
      {
        key: "use_electrical_devices_in_bathroom",
        label: "Does anyone use electrical appliances/devices in the bathroom?",
      },
      {
        key: "use_electric_blankets",
        label: "Does anyone use electric blankets?",
      },
    ],
  },
  {
    title: "Home Appliances & Heating",
    questions: [
      {
        key: "use_block_adapters_or_extensions",
        label:
          "Does anyone use block adapters or extension leads in your home?",
      },
      {
        key: "use_hair_straighteners",
        label: "Does anyone use hair straighteners in your home?",
      },
      {
        key: "use_mobility_scooter",
        label: "Does anyone living at your home use a mobility scooter?",
      },
      {
        key: "use_portable_heaters",
        label:
          "Do you have portable heaters, such as fan, ceramic or gas heaters or paraffin heaters in your home?",
      },
      {
        key: "clothes_dried_near_fire",
        label:
          "Are clothes ever dried in front of fires or heaters? (not including radiators)",
      },
      {
        key: "use_wood_burning_stove",
        label: "Is a wood-burning stove or open fire used?",
      },
      {
        key: "is_chimney_swept_yearly",
        label: "Do you get the chimney swept every year?",
      },
      {
        key: "use_lit_candles_or_incense",
        label:
          "Does anyone use lit candles, incense sticks or oil burners in your home?",
      },
      {
        key: "use_plugin_air_fresheners",
        label: "Does anyone use plug-in air fresheners in your home?",
      },
      {
        key: "use_wheat_bags",
        label: "Does anyone use wheat bags in your home?",
      },
    ],
  },
  {
    title: "Home Safety & Escape Plan",
    questions: [
      {
        key: "are_wheelie_bins_stored_away",
        label: "Are wheelie bins stored away after collection?",
      },
      {
        key: "are_internal_doors_closed_at_night",
        label: "Are internal doors closed at night?",
      },
      {
        key: "are_appliances_unplugged_at_night",
        label:
          "Are electrical appliances unplugged or switched off at night? (Unless they are designed to be left on, such as freezers)",
      },
      {
        key: "are_candles_left_burning",
        label:
          "Are candles, oil burners or incense burners left burning at night or when people are asleep?",
      },
      {
        key: "are_keys_accessible",
        label: "Are door and window keys kept where everyone can access them?",
      },
      {
        key: "has_escape_plan",
        label:
          "Is there an escape plan, so everyone in the house knows what to do if the smoke alarm goes off during the night?",
      },
      {
        key: "are_hallways_clear",
        label:
          "Are hallways, stairs and landings kept clear enough to allow safe and easy escape?",
      },
      {
        key: "can_escape_through_all_exits",
        label:
          "Would people in your home be able to escape through all exit doors and without having to search for a key?",
      },
    ],
  },
  {
    title: "Personal Factors",
    questions: [
      {
        key: "has_mobility_difficulties",
        label:
          "Does anyone have mobility difficulties and would require assistance to evacuate from the home?",
      },
      {
        key: "has_mental_illness",
        label:
          "Does anyone have a mental health illness and would require assistance to evacuate from the home?",
      },
      {
        key: "takes_medication_preventing_hearing_alarm",
        label:
          "Does anyone take medication that would prevent them from hearing a smoke alarm?",
      },
      {
        key: "has_hearing_impairment",
        label:
          "Does anyone have a hearing impairment that would prevent them from hearing a smoke alarm?",
      },
      {
        key: "has_visual_impairment",
        label:
          "Does anyone have a visual impairment and would be unable to escape in the event of a fire?",
      },
      {
        key: "consumes_alcohol_or_drugs",
        label:
          "Does anyone consume alcohol or use social drugs that would prevent them from hearing a smoke alarm?",
      },
      { key: "is_anyone_over_65", label: "Is anyone in your home over 65?" },
      {
        key: "is_anyone_under_16",
        label: "Is anyone in your home under 16?",
      },
      { key: "is_anyone_under_5", label: "Is anyone in your home under 5?" },
      {
        key: "does_anyone_use_oxygen_at_home",
        label:
          "Does anyone at the property use oxygen at home? (E.g. for medical purposes)",
      },
      {
        key: "has_arson_threat_concerns",
        label: "Does anyone in your home have any concerns over arson threats?",
      },
    ],
  },
];
